import { Link2 } from 'lucide-react';

// Small "Linked" pill marking a file or folder that's already linked into the
// workspace. Shared by FileRow and FolderRow so the badge stays consistent.
// With `count`, it instead shows that many linked items nested inside a folder
// (the count percolated up from descendants) rather than the folder itself.
export default function LinkedBadge({ className = '', count }: { className?: string; count?: number }) {
    const showCount = typeof count === 'number';
    return (
        <span
            className={`inline-flex items-center gap-1 text-[10px] font-medium text-state-success bg-state-success/15 border border-state-success/30 rounded px-1.5 py-0.5 shrink-0 ${className}`}
            title={showCount ? `${count} linked item${count === 1 ? '' : 's'} inside this folder` : 'Linked to a document'}
        >
            <Link2 className="w-2.5 h-2.5" />
            {showCount ? count : 'Linked'}
        </span>
    );
}
